module.exports = __webpack_public_path__ + "static/05-92ac377ef93a0103618ab30dae11f256.jpg";